import React, { useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import Button from '../buttons/button';
import { useUpdateMappingMutation, useGetMappingListByIdQuery } from '../../../app/stageMappingApi/stageMappingApi';
import { showToast } from '../../../helpers/Utils';
import CommonModal from '../modalLayout/CommonModal';
import Loader from '../loader/Loader';
import InputWithLabel from '../fields/InputWithLabel';
const UpdateStageMappingModal = ({ stageId, setShow, show }) => {
    const [description, setDescription] = useState('');
    const [label, setLabel] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [previewImage, setPreviewImage] = useState('');
    const previewUrlRef = useRef(null); // To keep track of object URL for cleanup

    const [updateStageMapping, { isLoading }] = useUpdateMappingMutation();

    const {
        data: mappingById,
        isLoading: isMappingByIdLoading,
        isFetching,
    } = useGetMappingListByIdQuery({ stageId }, { skip: !stageId });

    // Populate form fields when data is fetched
    useEffect(() => {
        if (mappingById?.data) {
            setLabel(mappingById?.data.label || '');
            setDescription(mappingById?.data.description || '');
            setPreviewImage(mappingById?.data.label_image || '');
        }
    }, [mappingById]);

    // Handle image selection and generate preview
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            const previewUrl = URL.createObjectURL(file);
            // Revoke previous object URL if any
            if (previewUrlRef.current) {
                URL.revokeObjectURL(previewUrlRef.current);
            }
            previewUrlRef.current = previewUrl;
            setPreviewImage(previewUrl);
        }
    };

    // Cleanup object URL on unmount or when previewImage changes
    useEffect(() => {
        return () => {
            if (previewUrlRef.current) {
                URL.revokeObjectURL(previewUrlRef.current);
            }
        };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!description || !label) {
            showToast('Please fill in all required fields.', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('description', description);
        formData.append('label', label);
        if (imageFile) {
            formData.append('image', imageFile);
        }

        try {
            await updateStageMapping({ stageId, formData }).unwrap();
            setShow(false);
        } catch (err) {
            console.log(err, "err");
            showToast(err?.data?.message || 'Update failed', 'error');
        }
    };

    return (
        <CommonModal show={show} setShow={setShow} title="Update stage mapping">
            {isMappingByIdLoading || isFetching ? (
                <Loader />
            ) : (
                <Form onSubmit={handleSubmit}>
                    {/* Odoo Stage Name */}

                    <InputWithLabel
                        label={'App Label'}
                        type="text"
                        value={label}
                        onChange={(e) => setLabel(e.target.value)}
                        placeholder="Enter App label"
                    />
                    <InputWithLabel
                        label={'Description'}
                        type="text"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Enter Odoo stage name"
                    />

                    {/* Image Upload */}
                    <InputWithLabel
                        label={'Image'}
                        type="file"
                        onChange={handleImageChange}
                        accept="image/*"
                    />

                    {previewImage && (
                        <div className="mt-2 mb-3">
                            <strong>Image Preview:</strong>
                            <br />
                            <img
                                src={previewImage}
                                alt="Stage Preview"
                                style={{
                                    width: '100px',
                                    height: 'auto',
                                    marginTop: '5px',
                                    border: '1px solid #ccc',
                                }}
                            />
                        </div>
                    )}

                    {/* Submit Button */}
                    <Button label={isLoading ? 'Updating...' : 'Update'} type="submit" />
                </Form>
            )}
        </CommonModal>
    );
};

export default UpdateStageMappingModal;